export default "__VITE_ASSET__CyYvqZAs__"